import { Input, Label, Select, Textarea } from "../../../../../../components"
import { Controller, useFormContext } from "react-hook-form"
import type { ListBrand } from "../../types"
import { useDropdownGroupAsset } from "../../utils"

type FormType = { action?: string }
export function FormSection({ action }: FormType) {
  const { control } = useFormContext<ListBrand>()
  const isDisable = action === "DETAIL" || action === "DELETE"

  const dataGroupAsset = useDropdownGroupAsset()

  return (
    <table className="table">
      <tbody>
        <Controller
          control={control}
          name="mr_brand_code"
          render={({ field, fieldState }) => 
            <tr>
              <td><Label text="CODE" error={Boolean(fieldState.error)} /></td>
              <td>
                <Input {...field} 
                  placeholder="Input brand code" 
                  value={field.value ?? ""} 
                  error={fieldState.error?.message} 
                  disabled={isDisable} 
                />
              </td>
            </tr>
          }
        />

        <Controller
          control={control}
          name="mr_group_id"
          render={({ field, fieldState }) => 
            <tr>
              <td><Label text="GROUP ASSET" error={Boolean(fieldState.error)} /></td>
              <td>
                <Select
                  className="my-1"
                  placeholder="Select group asset..."
                  isDisabled={isDisable}
                  isLoading={dataGroupAsset?.isLoading}
                  error={fieldState.error?.message}
                  options={dataGroupAsset?.data}
                  value={dataGroupAsset?.data.find(item => item.value?.toString() === field.value?.toString())}
                  onChange={e => field.onChange(e?.value)}
                />
              </td>
            </tr>
          }
        />

        <Controller
          control={control}
          name="mr_brand_name"
          render={({ field, fieldState }) => 
            <tr>
              <td><Label text="BRAND" error={Boolean(fieldState.error)} /></td>
              <td>
                <Input 
                  {...field} 
                  placeholder="Input brand name" 
                  value={field.value ?? ""} 
                  error={fieldState.error?.message} 
                  disabled={isDisable} 
                />
              </td>
            </tr>
          }
        />

        <Controller
          control={control}
          name="description"
          render={({ field, fieldState }) => 
            <tr>
              <td><Label text="DESCRIPTION" /></td>
              <td>
                <Textarea 
                  {...field} 
                  placeholder="Input Description" 
                  value={field.value ?? ""}
                  disabled={isDisable} 
                  error={fieldState.error?.message}
                />
              </td>
            </tr>
          }
        />
      </tbody>
    </table>
  )
}